

export enum ExecutionWorkflowType {

    DataCleaningWorkflow = "data_cleaning_workflow",
    NCAWorkflow = "nca_workflow",
    NCAValidation = "nca_validation"

}